import * as React from 'react';
import { Menu, MenuItem, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from 'react-i18next';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { pushToast, useDispatch, useSelector } from '../../state';
import { deletePurchaseOrder } from '../../state/purchaseOrderModalSlice';
import { searchPurchaseOrders } from '../../state/purchaseOrderBrowseSlice';
import type { PurchaseOrderSearchInput } from '@repo/api-contract';
import { serverLatencyMessage } from '../modals/constants/messages';

interface HeaderElipseProps {
  selectedRows: GridRowSelectionModel;
}

export default function BasicMenu({ selectedRows }: HeaderElipseProps) {
  const { t: tGTI } = useTranslation([], {
    keyPrefix: 'team.Global.Tables.ItemOptions',
  });

  const dispatch = useDispatch();
  const { searchInput, searchBy } = useSelector(
    (store) => store.purchaseOrderBrowseSlice,
  );

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [deleting, setDeleting] = React.useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const OptionsMUIIconSize = 30;
  const MenuItemMUIColor = 'rgb(51, 99, 255)';
  const hasSelection = selectedRows.length > 0;

  const handleDeleteSelected = async () => {
    handleClose();
    if (!hasSelection) return;
    setDeleting(true);
    try {
      await Promise.all(
        selectedRows.map((id) => dispatch(deletePurchaseOrder(id as string))),
      );
      dispatch(
        pushToast({
          message: `${selectedRows.length} purchase order(s) deleted`,
          additionalInfo: serverLatencyMessage,
          type: 'success',
          duration: 7000,
        }),
      );
      const payload: PurchaseOrderSearchInput = {
        query: searchInput,
        searchBy,
        size: 100,
        page: 0,
      };
      dispatch(searchPurchaseOrders(payload));
    } catch (error) {
      console.error('Error deleting purchase orders:', error);
      dispatch(
        pushToast({
          message: 'Failed to delete some purchase orders',
          type: 'error',
        }),
      );
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div>
      <IconButton
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className="text-2xl tracking-tight border-0 rounded-full"
        disabled={deleting}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          onClick={handleDeleteSelected}
          disabled={!hasSelection || deleting}
          // style={{ color: hasSelection ? 'rgb(51, 99, 255)' : undefined }}
        >
          <DeleteIcon
            style={{ fontSize: OptionsMUIIconSize, color: MenuItemMUIColor }}
          />
          {tGTI('Delete Selected')}
        </MenuItem>
      </Menu>
    </div>
  );
}
